import { useContext, useEffect, useRef } from 'react';
import InventoryContext from '~/contexts/InventoryContext';
import { useUserData } from '~/contexts/UserContext';
import { logError, toError } from '~/utilities/errorHandlers';

// resets inventory pricing on log in or log out so we refetch pricing
const useResetInventoryPricing = (vehicleIds: number[]) => {
  const user = useUserData();
  const { resetInventoryPricing } = useContext(InventoryContext);
  const vehicleIdsRef = useRef(vehicleIds);
  useEffect(() => {
    vehicleIdsRef.current = vehicleIds;
  }, [vehicleIds]);

  useEffect(() => {
    if (vehicleIdsRef.current.length === 0) return;

    try {
      resetInventoryPricing();
    } catch (err) {
      logError(toError(err), { location: 'Pricing reset' });
    }
  }, [resetInventoryPricing, user.isLoggedIn]);
};

export default useResetInventoryPricing;
